import request from '@/utils/request'
import { getToken } from '@/utils/auth'

let finalInitNoteice = false
let timerNoteice = null

let listenData = {}
let listenObjects = {}

const initRequest = () => {
    if(getToken()) {
        let m = localStorage.getItem("sys_data_listener_message") ?? "0"
        let r = localStorage.getItem("sys_data_listener_recharge") ?? "0"
        let w = localStorage.getItem("sys_data_listener_withdraw") ?? "0"
        request({ url: 'api/listener/new_data?m=' + m + '&r=' + r + '&w=' + w, method: 'get'}).then(res => {
            listenData = res ?? {}
            postListens(listenData)
        }).finally(() => {
            if(!timerNoteice) {
                timerNoteice = setInterval(() => {
                    initRequest()
                }, 5000);
            }
        })
    }
}

export const refreshNoteice = () => {
    initRequest();
}

const postListens = (data) => {
    for(let key in listenObjects) {
        const fuc = listenObjects[key]
        if(typeof fuc === 'function') {
            fuc(listenData)
        }
    }
}

export const getListenData = () => {
    return listenData
}

export const setListenObjects = (name, fuc) => {
    listenObjects[name] = fuc
    postListens(listenData)
}

export const removeListenObjects = (name) => {
    delete listenObjects[name]
}

export default () => {
    if(finalInitNoteice === false) {
        finalInitNoteice = true
        initRequest()
    }
}